import api, { cooperplaceApi } from 'services/api';

const route = (type, id) => {
  if (!['vehicle', 'wagon'].includes(type) || !/^\d+$/.test(String(id)) || Number(id) < 1)
    throw new Error('Placa inválida.');
  return `${type === 'vehicle' ? 'vehicles' : 'wagons'}/${id}/control-tower`;
};
export const controlTowerService = {
  async read(type, id) {
    return (await cooperplaceApi.get(route(type, id))).data;
  },
  async history(type, id, cursor, signal) {
    return (
      await cooperplaceApi.get(`${route(type, id)}/history`, {
        params: { perPage: 20, ...(cursor ? { cursor } : {}) },
        signal,
      })
    ).data;
  },
  async save(type, id, payload, create = false) {
    return (await cooperplaceApi[create ? 'post' : 'put'](route(type, id), payload)).data;
  },
  async options(kind, search) {
    let data;
    if (kind === 'responsible')
      ({ data } = await cooperplaceApi.get('users', {
        params: { search, limit: 30, getInative: false },
      }));
    if (kind === 'costCenter')
      ({ data } = await cooperplaceApi.get('cost-center/by-user-companies', {
        params: { search },
      }));
    if (kind === 'dedicatedClient') {
      const document = search.replace(/[.\/\-\s]/g, '').toUpperCase();
      const byDocument = /^\d+$/.test(document) || /^[A-Z\d]{12}\d{2}$/.test(document);
      const response = await api.get('persons', {
        params: {
          is_client: 1,
          active: 1,
          [byDocument ? 'cgccpf' : 'social_name']: byDocument ? document : search,
        },
      });
      data = response.data?.data;
    }
    if (!Array.isArray(data)) throw new Error('Resposta inválida ao buscar opções.');
    return data
      .map((row) => ({
        id: row.id,
        name: row.username || row.name || row.social_name || row.socialName || row.label,
        cnpj: row.cgccpf || row.cnpj || row.cpfCnpj,
      }))
      .filter(
        (row) =>
          row.id &&
          (kind !== 'dedicatedClient' ||
            /^[A-Z\d]{12}\d{2}$/.test(
              String(row.cnpj || '')
                .replace(/[.\/\-\s]/g, '')
                .toUpperCase(),
            )),
      );
  },
};
export const errorMessage = (error) =>
  error?.response?.data?.message || error?.message || 'Não foi possível salvar. Tente novamente.';
